import React from 'react'
import { bool, object } from 'prop-types'
import { TALKDESK_LOGO } from '../../constants/images'
import { LOGO_ALTERNATE_TEXT } from '../../constants/ui.labels'
import {
  LOGIN_CREDENTIALS_SUBTITLE,
  LOGIN_IDENTITY_PROVIDER_SUBTITLE
} from '../../constants/ui.labels'
import {
  Brand,
  Image,
  Paragraph,
  Color,
  Spacer
} from '@cobalt/cobalt-react-components'
import { constantBuilder } from '../../utils/index'

const LoginHeader = props => {
  const {
    localLoginEnabled,
    brandingSettings: {
      branding: { assets, name }
    }
  } = props

  return (
    <div className="bottom-space" style={{ textAlign: 'center' }}>
      {assets && (
        <Brand>
          <Image
            src={TALKDESK_LOGO(assets)}
            alt={constantBuilder(LOGO_ALTERNATE_TEXT, { name })}
            height={32}
            width={160}
          />
        </Brand>
      )}
      <Spacer y={4} />
      <Paragraph color={Color.gray[600]}>
        {localLoginEnabled
          ? LOGIN_CREDENTIALS_SUBTITLE
          : LOGIN_IDENTITY_PROVIDER_SUBTITLE}
      </Paragraph>
    </div>
  )
}

LoginHeader.propTypes = {
  localLoginEnabled: bool.isRequired,
  brandingSettings: object.isRequired
}

export default LoginHeader
